//eslint-disable-next-line
export const bog_names = [
    {
        "position" : "Chairman",
        "Name" : "Prof. S. NARASIMHA RAO Retired Professor,IIT Madras 4/25B North Street, Kapaleswar Nagar, Nelangiri,Chennai",
        "Email":"kuttyharirao@gmail.com",
        "Phone" :"(+91)-9840778931",
    },
    {
        "position" : "Member",
        "Name" : "Dr. K. LAKSHMINARAYANA, I.A.S. (Retd.) 108, Navanirman Nagar Road No.71, Jubilee Hills Hyderabad â€“ 500 096.",
        "Email":"kln1951@gmail.com",
        "Phone" :"(+91)-9848012427",
    }
    ,
    {
        "position" : "Member",
        "Name" : "Er. B. GANGI REDDY Industrialist, Rathna Packaging Inadia(P) Limited, No.N-1, SIDCO Indl.Estate, Phase-III, Hosur-635 126.TN-India..",
        "Email":"rathnabiotec@yahoo.co.in",
        "Phone" :"(+91)-9347383024",
    }
    ,
    {
        "position" : "Member",
        "Name" : "Prof. B. VENKATESH KUMAR Professor & Chairperson, Center for Public and Governance, TISS Director, National Corporate Social Responsibility Hub, TISS,Tata Institute of Social Sciences, V.N. Purav Marg, Deonar, Mumbai â€“ 400 088.",
        "Email":"kumarbvenkatesh@gmail.com",
        "Phone" :"(+91)-9869578830",
    }
    ,
    ,
    {
        "position" : "Member",
        "Name" : "Prof. S.VIJAYA BHASKARA RAO Dept. of Physics, SVU College of Sciences, Tirupati.",
        "Email":"drsvbr.acas@gmail.com",
        "Phone" :"(+91)-9440953122",
    }
    ,
    {
        "position" : "Member",
        "Name" : "Prof. P. MALLIKARJUNA Department of Civil Engineering, SVUCE, Tirupati..",
        "Email":"drsvbr.acas@gmail.com",
        "Phone" :"(+91)-9491012899",
    }
    ,
    {
        "position" : "Member Invitee",
        "Name" : "Prof. G. PADMANABHAN Former Principal SVUCE, Tirupati.",
        "Email":"gpnsvuce@yahoo.co.in",
        "Phone" :"(+91)-9849505068",
    }
    ,
    {
        "position" : "Member",
        "Name" : "Prof. R.V.S. SATHYANARAYANA,Vice-Principal, Department of ECE, SVUCE, Tirupati",
        "Email":"v.s.ravinutala@gmail.com",
        "Phone" :"(+91)-9246204470",
    }
    ,
    {
        "position" : "Principal & Member Secretary",
        "Name" : "Prof. S. NARAYANA REDDY, Principal, Department of ECE, SVUCE, Tirupati.",
        "Email":"snreddysvu@yahoo.com",
        "Phone" :"(+91)-9848927815",
    }
    ,
    {
        "position" : "Member",
        "Name" : "PRINCIPAL, IGEC, Sagar - 470 021, Madhya Pradesh (Mentee Institute)",
        "Email":"dr.principalgec@rediffmail.com",
        "Phone" :"(+91)-7898066150",
    }
    
    
    ]
    
    // {
    //     "position" : "",
    //     "Name" : "",
    //     "Email":"",
    //     "Phone" :"",
    // }